<ng-container *ngIf="!isReadOnly; else disabledInput">
  <app-form-control-checkbox
    [label]="label"
    [name]="name"
    [id]="id"
    [choices]="choices"
    [formSubmitted]="formSubmitted"
    [showLabel]="showLabel"
    [showErrors]="showErrors"
    [showOptional]="showOptional"
    [isRequired]="isRequired"
    [showBorder]="showActiveBorder"
    [theme]="theme"
    [style]="style"
    [cols]="cols"
    (selected)="select($event)"
    [(ngModel)]="value"
  ></app-form-control-checkbox>
</ng-container>

<ng-template #disabledInput>
  <app-input-checkbox-disabled
    [label]="label"
    [theme]="theme"
    [style]="style"
    [isGrey]="isGrey"
    [hasBorder]="hasBorder"
    [values]="checkBoxAnswers"
    [choices]="choices"
  ></app-input-checkbox-disabled>
</ng-template>
